import { Box, FormControlLabel, styled, Typography } from '@mui/material';
import { fontSizes } from '../../../layouts/fontSizes';
import pallet from '../../../layouts/pallet';

const Title = styled(Typography)({
  fontSize: `${fontSizes.h4} !important`,
  paddingTop: 8,
  fontWeight: 'bold'
});

const PaperWrapper = styled(Box)(() => ({
  marginTop: 16,
  maxWidth: '100%',
  marginRight: 'auto',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 16,
  paddingBottom: 16,
  backgroundColor: pallet.N0,
  borderRadius: 6,
  boxShadow: `0px 3px 8px 0px ${pallet.boxShadow}`,
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  minHeight: 'auto',
  boxSizing: 'border-box'
}));

const PageWrapper = styled(Box)(() => ({
  marginTop: 16,
  maxWidth: '100%',
  marginRight: 'auto',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 16,
  paddingBottom: 16,
  backgroundColor: pallet.N0,
  borderRadius: 6,
  boxShadow: `0px 3px 8px 0px ${pallet.boxShadow}`,
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  minHeight: 'auto',
  boxSizing: 'border-box'
}));

const StyledRadioButton = styled(FormControlLabel)(() => ({
  margin: 0,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px !important',
  '&. MuiFormGroup-root': {
    gap: '8px !important'
  },
  '& .MuiRadio-root': {
    padding: 0,
    position: 'relative',
    '& .MuiSvgIcon-root': {
      width: 0,
      height: 0
    },
    '&::before': {
      content: '""',
      display: 'block',
      width: '18px',
      height: '18px',
      borderRadius: '50%',
      border: `2px solid ${pallet.radioButtonBorder}`,
      backgroundColor: pallet.white
    },
    '&.Mui-checked::before': {
      border: 'none',
      backgroundColor: pallet.primary,
      boxShadow: `0px 0px 4px ${pallet.radioButtonShadow}`
    },
    '&.Mui-checked::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '9px',
      width: '6px',
      height: '6px',
      backgroundColor: pallet.white,
      borderRadius: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }
}));

export { Title, PaperWrapper, PageWrapper, StyledRadioButton };
